import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('authfack', {
      currentUser: (state) => state,
  }),
  ...mapGetters('authfack', ['userdata','loading', 'settings']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}



export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'logout','loadingStatus','forgotPassword'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

